module.exports = __webpack_public_path__ + "static/2-97f9ddceb71bf79bed7d9f8ce9bd4717.jpg";